import axios from 'axios';
import { TokenLogout } from 'API/Logout/logout';

const url = process.env.REACT_APP_BACKEND_URL;

export const BrandingLanguage = async (setBrandLang) => {
  //   setIsLoading(true);
  try {
    await axios
      .get(`${url}/branding/languages`, {
        headers: {
          Authorization:`Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        if (res.status === 200) {
          //   setIsLoading(false);
          setBrandLang(res.data);
        }
      });
  } catch (error) {
    // setIsLoading(false);
    TokenLogout(error);
  }
};

export const AddLanguage = async (NewLang, setIsLoading, setSuccess, setError, setOpen, refunction, setNewLang) => {
  setIsLoading(true);
  try {
    await axios
      .post(
        `${url}/branding/languages/add`,
        { language: NewLang },
        {
          headers: {
            Authorization:`Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 201) {
          setOpen(false);
          setSuccess(res.data.message);
          setNewLang(null);
          setTimeout(() => {
            setIsLoading(false);
            refunction();
          }, 200);
        }
      })
      .catch((error) => {
        setError(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
        setIsLoading(false);
        TokenLogout(error);
      });
  } catch (error) {
    setError(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
    setIsLoading(false);
    TokenLogout(error);
  }
};

export const BrandingBank = async (setBank) => {
  // setIsLoading(true)
  try {
    await axios
      .get(`${url}/branding/banks`, {
        headers: {
          Authorization:`Bearer ${sessionStorage.getItem('token')}`
        }
      })
      .then((res) => {
        if (res.status === 200) {
          setBank(res.data);
          //  setIsLoading(false);
        }
      })
      .catch((error) => {
        // setIsLoading(false);
        TokenLogout(error);
      });
  } catch (error) {
    // setIsLoading(false);
    TokenLogout(error);
  }
};

export const BrandUpload = async (Data, photoFiles, setIsLoading, setSuccess, setError, handleSuccess) => {
  setIsLoading(true);
  const formdata = new FormData();
  formdata.append('bank_id', Data.bank && Data.bank._id);
  formdata.append('bank_name', Data.bank && Data.bank.name);
  formdata.append('language', Data.language);
  photoFiles.forEach((file) => {
    formdata.append(`files`, file);
  });
  try {
    await axios
      .post(`${url}/branding/upload`, formdata, {
        headers: {
           Authorization:`Bearer ${sessionStorage.getItem('token')}`
          // 'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => {
        if (res.status === 200) {
          setSuccess(res.data.message);
          setTimeout(() => {
            setIsLoading(false);
            handleSuccess();
          }, 1500);
        }
      })
      .catch((error) => {
        setError(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
        setIsLoading(false);
        TokenLogout(error);
      });
  } catch (error) {
    setError(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
    setIsLoading(false);
    TokenLogout(error);
  }
};

export const BrandListApi = async (page, limit, filters, setIsLoading, setBranList, setError, setTotalCount) => {
  setIsLoading(true);
  const params = {};
  if (page) {
    params.page = page;
  }
  if (limit) {
    params.limit = limit;
  }
  if (filters.agent_code) {
    params.agent_code = filters.agent_code;
  }
  if (filters.csp_code) {
    params.csp_code = filters.csp_code;
  }
  if (filters.date) {
    params.date = filters.date;
  }
  if (filters.status) {
    params.status = filters.status;
  }
  try {
    await axios
      .get(`${url}/branding/list`, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem('token')}`
        },
        params
      })
      .then((res) => {
        if (res.status === 200) {
          setBranList(res.data.data);
          setTotalCount(res.data.total);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        console.log('error', error);
        setError(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
        setIsLoading(false);
      });
  } catch (error) {
    TokenLogout(error);
    console.log('error', error);
    setError(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
    setIsLoading(false);
  }
};

export const BrandingStatusUpdate = async (CheckData, data, setIsLoading, setSuccess, setError, refuncion) => {
  setIsLoading(true);
  try {
    await axios
      .post(
        `${url}/branding/status-update`,
        {
          user_id: CheckData.user_id,
          request_id: CheckData.branding && CheckData.branding.request_id,
          status: data
          //  remarks: 'optional'
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setSuccess(res.data.message);
          setTimeout(() => {
            setIsLoading(false);
            refuncion();
          }, 1000);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        console.log('error', error);
        setError(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
        setIsLoading(false);
      });
  } catch (error) {
    TokenLogout(error);
    console.log('error', error);
    setError(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
    setIsLoading(false);
  }
};

export const BrandView = async (imageUrl, setImageFile, setImageType, handleImageOpen, setLoading, setError) => {
  try {
    setLoading(true);
    await axios
      .post(
        `${url}/branding/download`,
        { url: imageUrl },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          },
          responseType: 'arraybuffer'
        }
      )
      .then((response) => {
        if (response.status === 200) {
          handleImageOpen();
          const blob = new Blob([response.data], {
            type: response.headers['content-type']
          });
          const imageUrl = URL.createObjectURL(blob);
          setImageFile(imageUrl);
          setImageType(response.headers['content-type'] === 'application/pdf' ? 'pdf' : 'img');
          setLoading(false);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        console.log('error', error);
        setError(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
        setLoading(false);
      });
  } catch (error) {
    console.log(error);
    setLoading(false);
    setError(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
    // console.clear();
    TokenLogout(error);
  }
};

export const DownloadImages = async (imageUrl, name, handleOpenAlert, handleOpen, handleClose) => {
  try {
    handleOpen();
    await axios
      .post(
        `${url}/branding/download`,
        { url: imageUrl },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          },
          responseType: 'arraybuffer'
        }
      )
      .then((response) => {
        handleClose();
        if (response.status === 200) {
          console.log(response.data);
          const contentType = response.headers['content-type'];
          const blob = new Blob([response.data], { type: contentType });

          let fileExtension = name;
          if (contentType === 'application/pdf') {
            fileExtension = `${name}.pdf`;
          } else if (contentType.startsWith('image/')) {
            fileExtension = `${name}.jpg`;
          } else {
            fileExtension = `${name}.bin`;
          }
          const imageUrl = URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = imageUrl;
          a.download = fileExtension;
          a.click();
          URL.revokeObjectURL(imageUrl);
        }
      });
  } catch (error) {
    handleClose();
    // console.log(error);
    handleOpenAlert();
    // console.clear();
    TokenLogout(error);
  }
};

export const WithCspBrand = async (
  page,
  limit,
  filter,
  setIsLoading,
  setCspBrand,
  setError,
  setTotalCount,
  setNoWithoutBrand,
  setNoWithBrand
) => {
  setIsLoading(true);
  try {
    await axios
      .post(
        `${url}/branding/dashboard/csp?page=${page}&limit=${limit}`,
        {
          ...(filter.user_type === 'agent_name' && { agent_name: filter.search }),
          ...(filter.user_type === 'agent_code' && { agent_code: filter.search }),
          ...(filter.user_type === 'bank_name' && { bank_name: filter.search }),
          ...(filter.user_type === 'csp_code' && { csp_code: filter.search }),
          ...(filter.retail_state && { retail_state: filter.retail_state }),
          ...(filter.retail_district && { retail_district: filter.retail_district })

          //   "agent_name": "",
          // "agent_code": "",
          // "bank_name": "",
          // "csp_code": "",
          // "retail_state": "" ,
          // "retail_district": ""
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setCspBrand(res.data.all_branding);
          setTotalCount(res.data.total_count);
          setNoWithBrand(res.data.no_of_branding);
          setNoWithoutBrand(res.data.no_of_without_branding);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setError(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
        setIsLoading(false);
      });
  } catch (error) {
    TokenLogout(error);
    setError(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
    setIsLoading(false);
  }
};

export const BrandStatusUpdate = async (data, status, setIsLoading, setSuccess, setError, handleClick, refunctionwith) => {
  setIsLoading(true);
  try {
    await axios
      .post(
        `${url}/branding/status-update`,
        {
          status: status,
          // "status": "rejected"
          remarks: data.remarks,
          user_id: data.user_id,
          branding_created_at: data.created_at,
          request_id: data.request_id
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setSuccess(res.data.success);
          setTimeout(() => {
            setIsLoading(false);
            handleClick();
            refunctionwith();
          }, 1500);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setError(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
        setIsLoading(false);
      });
  } catch (error) {
    TokenLogout(error);
    setError(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
    setIsLoading(false);
  }
};

export const WithoutCspBrand = async (page, limit, filter, setIsLoading, setCspBrand, setError, setTotalCount) => {
  setIsLoading(true);
  try {
    await axios
      .post(
        `${url}/branding/dashboard/csp/without?page=${page}&limit=${limit}`,
        {
          ...(filter.user_type === 'agent_name' && { agent_name: filter.search }),
          ...(filter.user_type === 'agent_code' && { agent_code: filter.search }),
          ...(filter.user_type === 'bank_name' && { bank_name: filter.search }),
          ...(filter.user_type === 'csp_code' && { csp_code: filter.search }),
          ...(filter.retail_state && { retail_state: filter.retail_state }),
          ...(filter.retail_district && { retail_district: filter.retail_district })

          //   "agent_name": "",
          // "agent_code": "",
          // "bank_name": "",
          // "csp_code": "",
          // "retail_state": "" ,
          // "retail_district": ""
        },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setCspBrand(res.data.all_without_branding);
          setTotalCount(res.data.total_count);
          setIsLoading(false);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setError(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
        setIsLoading(false);
      });
  } catch (error) {
    TokenLogout(error);
    setError(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
    setIsLoading(false);
  }
};

export const BrandEmail = async (DialogData, setIsLoading, setSuccess, setError, setConfirmDialog, refunctionwithOut) => {
  setIsLoading(true);
  try {
    await axios
      .post(
        `${url}/branding/dashboard/csp/send_email`,
        { user_id: DialogData },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('token')}`
          }
        }
      )
      .then((res) => {
        if (res.status === 200) {
          setSuccess(res.data.message);
          setTimeout(() => {
            setIsLoading(false);
            setConfirmDialog(false);
            refunctionwithOut();
          }, 1500);
        }
      })
      .catch((error) => {
        TokenLogout(error);
        setError(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
        setIsLoading(false);
      });
  } catch (error) {
    TokenLogout(error);
    setError(error.response && error.response.data.error ? error.response.data.error : 'Something went wrong');
    setIsLoading(false);
  }
};
